import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";


@Component({
	selector: 'collaboration-protection-rules-component',
	templateUrl: './collaboration-protection-rules.component.html',
})
export class CollaborationProtectionRulesComponent implements OnInit {
	constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService) {
	}

	format = util.format;
	dic = DICTIONARY;

	userInfo;
	config;
	rules = [];
	fileTypes;
	newRule;
	getRulesDataInProcess;
	createNewRulesInProcess;
	prepareRuleInProcess;
	invalidRuleName;
	invalidResults = false;
	sensitivity_types;
	isSensitivityTypesEnabled = false;

	ruleUsagePopupData;
	searchResultsText = '';
	searchResultNotFound = false;

	ngOnInit() {
		this.getCollaborationProtectionRules();

		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});
	};

	getCollaborationProtectionRules = () => {
		this.getRulesDataInProcess = true;
		this.rs.getCollaborationProtectionRules().then((response) => {
			this.config = response;

			this.fileTypes = response.fileTypes;
			this.prepareSensitivityTypes(response.sensitivityTypes);
			this.isSensitivityTypesEnabled = response.scan_sensitivity?.enabled;

			if (!this.config.rules) {
				this.config.rules = [];
			}

			this.rules = this.config.rules;
			this.parseRulesResultAndExceptions(this.rules);
			this.getRulesDataInProcess = false;
		}, (err) => {
			this.getRulesDataInProcess = false;
		});
	};

	createNewRule = () => {
		this.newRule = {
			conditions: [
				[this.getNewCondition()]
			],
			exceptions: [],
			result: _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.defaultResult),
			resultShow: []
		};

		this.createNewRulesInProcess = true;
	};

	addExceptionToRule() {
		if (!this.newRule.exceptions) {
			this.newRule.exceptions = [];
		}
		this.newRule.exceptions.push([this.getNewException()]);
	};

	addConditionToRule() {
		this.newRule.conditions.push([this.getNewCondition()]);
	};

	addORtoCondition = (condition) => {
		condition.push(this.getNewCondition());
	}

	getNewCondition = () => {
		const defaultSubtype = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.types[this.dic.CONSTANTS.collaborationProtectionRule.defaultCondition.type].subTypes);

		return _.cloneDeep({
			...this.dic.CONSTANTS.collaborationProtectionRule.defaultCondition,
			subType: defaultSubtype,
			subTypeShow: this.parseSubType(defaultSubtype),
		});
	}

	getNewException = () => {
		const defaultSubtype = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.types[this.dic.CONSTANTS.collaborationProtectionRule.defaultExcept.type].subTypes);

		return _.cloneDeep({
			...this.dic.CONSTANTS.collaborationProtectionRule.defaultExcept,
			subType: defaultSubtype,
			subTypeShow: this.parseSubType(defaultSubtype),
		});
	}

	prepareSensitivityTypes = (sensitivityTypes) => {
		this.sensitivity_types = [];
		sensitivityTypes?.forEach((sensObj) => {
			this.sensitivity_types.push(sensObj);
			if (sensObj.sub_detector?.length) {
				sensObj.sub_detector.forEach((subDetector) => {
					this.sensitivity_types.push(subDetector);
				});
			}
		});
	}

	showRulesUsage = (ruleObj) => {
		this.ruleUsagePopupData = {
			show: true,
			ruleObj: ruleObj
		};
	};

	showRuleActions = () => {
		return [
			this.dic.CONSTANTS.inboundRulesActions.edit,
			this.dic.CONSTANTS.inboundRulesActions.clone,
			this.dic.CONSTANTS.inboundRulesActions.delete
		];
	}

	selectRuleAction = (rule, action) => {
		switch (action) {
			case this.dic.CONSTANTS.inboundRulesActions.edit:
				this.startEditRule(rule);
				break;

			case this.dic.CONSTANTS.inboundRulesActions.clone:
				this.cloneRule(rule);
				break;

			case this.dic.CONSTANTS.inboundRulesActions.delete:
				this.openDeleteRulePopup(rule);
				break;
		}
	}

	selectMultipleRulesAction = (selectedRules, action) => {
		switch (action) {
			case this.dic.CONSTANTS.rulesActions.delete:
				this.openDeleteRulesPopup(selectedRules);
				break;

			case this.dic.CONSTANTS.rulesActions.enable:
				this.updateRuleState(selectedRules, true);
				break;

			case this.dic.CONSTANTS.rulesActions.disable:
				this.updateRuleState(selectedRules, false);
				break;
		}
	}

	showMultipleRulesActions = () => {
		return [
			this.dic.CONSTANTS.rulesActions.enable,
			this.dic.CONSTANTS.rulesActions.disable,
			this.dic.CONSTANTS.rulesActions.delete
		];
	}

	searchRule = (searchTerm, activeFilters) => {
		this.rules.forEach(record => {
			const isFound = searchTextExecute(record, searchTerm);
			if (!isFound) {
				record.hide = true;
				return;
			}

			record.hide = false;
		});
	}

	updateRulePriority = (dragItem, draggedOnTopItem=null) => {
		if (!dragItem) {
			return;
		}

		const isMoveForward = draggedOnTopItem && this.rules.indexOf(draggedOnTopItem) > this.rules.indexOf(dragItem);

		const moveToIndex = draggedOnTopItem ? this.rules.indexOf(draggedOnTopItem) - (isMoveForward ? 1 : 0) : this.rules.length - 1;

		const ruleData:any = {
			action: this.dic.CONSTANTS.collaborationProtectionRule.actions.move,
			idx: moveToIndex
		};

		this.rs.updateCollaborationProtectionRule(dragItem._id, ruleData).then(response => {
			this.rules = response.rules;
			this.config.rules = this.rules;
			this.parseRulesResultAndExceptions(this.rules);
			this.ns.overwriteMessage(null, this.dic.MESSAGES.rulePriorityUpdated);
		});
	}

	updateRuleState = (rules, action) => {
		rules.forEach(rule => {
			const ruleData = {
				action: this.dic.CONSTANTS.collaborationProtectionRule.actions.toggleState,
				enabled: action
			};

			this.rs.updateCollaborationProtectionRule(rule._id, ruleData).then(response => {
				rule.enabled = ruleData.enabled;
			});
		});
	};

	parseRulesResultAndExceptions = (rules) => {
		for (let i = 0; i < rules.length; i++) {
			rules[i].priority = i;
			rules[i].priorityDisplay = this.gs.addOrdinalNumberSuffix(i + 1);

			if (rules[i].conditions?.length) {
				rules[i].conditions = _.map(rules[i].conditions, condition => {
					if (condition.or_conditions?.length) {
						return condition.or_conditions
					}
					else {
						return [condition]
					}
				});

				rules[i].conditions.forEach(conditionArr => {
					conditionArr.forEach(cond => {
						this.getRuleConditionText(cond);
					});
				});
			}

			if (rules[i].exceptions?.length) {
				rules[i].exceptions = _.map(rules[i].exceptions, condition => {
					if (condition.or_conditions?.length) {
						return condition.or_conditions
					}
					else {
						return [condition]
					}
				});

				rules[i].exceptions.forEach(conditionArr => {
					conditionArr.forEach(cond => {
						this.getRuleConditionText(cond);
					});
				});
			}

			if (!rules[i].result) {
				continue;
			}
			rules[i].resultShow = [];
			_.each(Object.keys(rules[i].result), (key) => {
				if (rules[i].result[key] && this.dic.CONSTANTS.collaborationProtectionRule.defaultResult[key]) {
					rules[i].resultShow.push(this.dic.CONSTANTS.collaborationProtectionRule.defaultResult[key].label);
				}
			});
		}
	};

	resetNewRuleData = () => {
		this.newRule = null;
		this.createNewRulesInProcess = false;
		this.prepareRuleInProcess = false;
	};

	cancelNewRule() {
		this.resetNewRuleData();
	};

	cloneRule(rule) {
		this.newRule = _.cloneDeep(rule);
		this.setRuleForEdit();
		this.newRule._id = null;
		this.newRule.name = `Clone of ${rule.name}`;
		this.createNewRulesInProcess = true;
	}

	startEditRule(rule) {
		this.newRule = _.cloneDeep(rule);
		this.setRuleForEdit();
		this.createNewRulesInProcess = true;
	};

	setRuleForEdit = () => {
		let result:any = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.defaultResult);
		result.keep_record.enabled = this.newRule.result.keep_record;
		result.notify_reviewer.enabled = this.newRule.result.notify_reviewer;
		result.quarantine_file.enabled = this.newRule.result.quarantine_file;

		this.newRule.result = result;

		this.newRule.conditions = this.parseEditRuleConditions(this.newRule.conditions, false);

		this.newRule.exceptions = this.parseEditRuleConditions(this.newRule.exceptions, true);
	};

	parseEditRuleConditions = (conditions, isException) => {
		return _.map(conditions, conditionArr => {
			conditionArr.forEach(c => {
				c.subType = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.types[c.type].subTypes);
				c.singleSubType = this.dic.CONSTANTS.collaborationProtectionRule.types[c.type].singleSubType || (c.subType instanceof Array && c.subType.length === 1);
				if (c.data?.attachment_types) {
					c.data.typesDisplay = c.data.attachment_types.map(type => this.fileTypes[type]?.display).join(', ');
				}
				if (!c.singleSubType && c.subType) {
					c.subType = _.mapValues(c.subType, (subTypeEnabled, subTypeKey) => {
						return c.sub_type.includes(subTypeKey);
					});
				}
				c.isException = isException;
				delete c.sub_type;

				if (c.data && c.data.compliance) {
					let compliance = _.cloneDeep(this.dic.CONSTANTS.collaborationProtectionRule.defaultCondition.data.compliance);
					compliance = _.mapValues(compliance, (complianceVal, complianceKey) => {
						complianceVal.enabled = c.data.compliance.includes(complianceKey);
						return complianceVal;
					});
					c.data.compliance = compliance;
					this.updateComplianceShow(c.data);
				}
			});

			return conditionArr;
		});
	}

	updateComplianceShow(conditionData) {
		conditionData.complianceShow = [];
		_.each(Object.keys(conditionData.compliance), (key) => {
			if (conditionData.compliance[key] && conditionData.compliance[key].enabled) {
				conditionData.complianceShow.push(key);
			}
		});
	};

	openDeleteRulesPopup(rules) {
		this.gs.showPopup({
			title: `Delete ${rules.length} Rules`,
			subTitle: 'Please note - the selected rules will be deleted.',
			body: ["Rule will not be available for all future items"],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.deleteRules(rules);
			}
		});
	};

	openDeleteRulePopup = (rule) => {
		this.gs.showPopup({
			title: `Delete Rule: ${rule.name}`,
			subTitle: 'Please note - the selected rule will be deleted.',
			body: ["Rule will not be available for all future items"],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.deleteRule(rule);
			}
		});
	};

	deleteRules(rules) {
		let deletePromises = [];

		rules.forEach(rule => {
			let deletePromise = this.rs.deleteCollaborationProtectionRule(rule._id).then(res => {
				_.remove(this.rules, {_id: rule._id});
				return true;
			}).catch(err => {
				console.error('Failed to delete rule:', err);
				return false;
			});

			deletePromises.push(deletePromise);
		});

		Promise.all(deletePromises).then(results => {
			let successDelete = results.filter(result => result).length;
			if (successDelete > 0) {
				this.ns.showInfoMessage(`${successDelete} rules deleted successfully`);
			}
		}).catch(error => {
			console.error('Error in processing rule deletions:', error);
		});
	}

	deleteRule = (rule) => {
		this.rs.deleteCollaborationProtectionRule(rule._id).then(res => {
			_.remove(this.rules, {_id: rule._id});
			this.ns.showInfoMessage(this.dic.MESSAGES.ruleDeleted);
		});
	};

	isNameChanged = () => {
		this.ns.closeMessage();
		this.invalidRuleName = false;
	};

	parseNewRuleResult = (lastResult=null) => {
		if (!this.newRule?.result) {
			return;
		}
		this.newRule.resultShow = [];

		_.each(Object.keys(this.newRule.result), key => {
			if (this.newRule.result[key] && this.newRule.result[key].enabled) {
				this.newRule.resultShow.push(this.dic.CONSTANTS.collaborationProtectionRule.defaultResult[key].label);
			}
		});
	};

	isResultChanged = (result=null) => {
		this.ns.closeMessage();
		this.parseNewRuleResult();
		this.invalidResults = false;
	};

	parseSubType = (subType) => {
		let res = [];
		_.map(subType, (value, key) => {
			if (value) {
				res.push(key);
			}
		});
		return res;
	};

	prepareRuleConditions = (conditions) => {
		let conditionError = false;
		this.newRule.conditionAddresses = [];

		let parsedConditions = _.map(conditions, conditionArr => {
			let data:any = {};

			if (conditionArr.length > 1) {
				const orConditionBackendFormat = this.buildOrConditionforBE(conditionArr);
				const parsedOrConditions = this.prepareRuleConditions(orConditionBackendFormat.or_conditions);

				if (parsedOrConditions.error) {
					conditionError = true;
					return;
				}
				else {
					return {
						type: 'or_condition',
						sub_type: 'email',
						data: null,
						is_negate: false,
						or_conditions: parsedOrConditions.conditions
					}
				}
			}

			const c = conditionArr[0] || conditionArr;

			switch (c.type) {
				case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
					data.matchType = c.data.matchType;
					switch (data.matchType) {
						case this.dic.CONSTANTS.ruleMatchType.regex:
							if (!c.data.regex) {
								this.ns.showErrorMessage(this.dic.ERRORS.ruleKeywordEmpty);
								conditionError = true;
								c.invalidEmails = true;
								return;
							}
							data.regex = c.data.regex;
							data.regex_flags = c.data.regex_flags;
							break;

						case this.dic.CONSTANTS.ruleMatchType.exactMatch:
						case this.dic.CONSTANTS.ruleMatchType.contains:
							if (!c.data.keywords) {
								this.ns.showErrorMessage(this.dic.ERRORS.ruleKeywordEmpty);
								conditionError = true;
								c.invalidKeywords = true;
								return;
							}
							if (!(c.data.keywords instanceof Array)) {
								data.keywords = c.data.keywords.split(',');
								data.keywords = _.map(data.keywords, k => k.trim());
							}
							else {
								data.keywords = c.data.keywords;
								data.file = c.data.file;
							}
							break;
					}
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_type.name:
					data.matchType = c.data.matchType;
					if (!c.data.sensitivity_types?.length) {
						this.ns.showErrorMessage(this.dic.ERRORS.ruleSensitivityTypeEmpty);
						conditionError = true;
						c.invalidSensitivityType = true;
						return;
					}
					if (c.data.matchType === this.dic.CONSTANTS.ruleMatchType.moreThan) {
						if (!c.data.matchCount || typeof c.data.matchCount !== 'number' || c.data.matchCount < 1 || c.data.matchCount > 10) {
							conditionError = true;
							this.ns.showErrorMessage(this.dic.ERRORS.ruleSensitivityTypeCountInvalid);
							return;
						}
						if (c.subType.attachment) {
							this.ns.showErrorMessage(this.dic.ERRORS.ruleSensitivityTypeMoreThanAttachmentsInvalid);
							conditionError = true;
							c.invalidSubTypes = true;
							return;
						}

						data.matchCount = c.data.matchCount;
					}

					c.invalidSensitivityType = false;
					data.sensitivity_types = c.data.sensitivity_types;
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_score.name:
					data.score_more = c.data.score_more;
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.compliance.name:
					if (_.every(c.data.compliance, ['enabled', false])) {
						this.ns.showErrorMessage(this.dic.ERRORS.ruleComplianceEmpty);
						conditionError = true;
						c.invalidCompliance = true;
						return;
					}
					data.compliance = [];
					_.each(c.data.compliance, (compVal, compKey) => {
						if (compVal.enabled) {
							data.compliance.push(compKey);
						}
					});
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.attachment_types.name:
					if (!c.data.attachment_types?.length && !c.data.all_types) {
						this.ns.showErrorMessage(this.dic.ERRORS.ruleAttachmentsTypeEmpty);
						conditionError = true;
						c.invalidAttachmentsTypes = true;
						return;
					}
					else {
						data.attachment_types = c.data.attachment_types;
						data.all_types = c.data.all_types || undefined;
					}
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name:
					if (!c.data.file_permissions?.length) {
						this.ns.showErrorMessage(this.dic.ERRORS.ruleResourceTypeEmpty);
						conditionError = true;
						c.invalidResourceTypes = true;
						return;
					}
					data.file_permissions = c.data.file_permissions;
					break;

				case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
					data.matchType = c.data.matchType;
					if (data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch ||
						data.matchType === this.dic.CONSTANTS.ruleMatchType.startsWith ||
						data.matchType === this.dic.CONSTANTS.ruleMatchType.endsWith ||
						data.matchType === this.dic.CONSTANTS.ruleMatchType.contains) {
						if (!c.data.emails) {
							this.ns.showErrorMessage(this.dic.ERRORS.ruleEmailEmpty);
							conditionError = true;
							c.invalidEmails = true;
							return;
						}
						if (!(c.data.emails instanceof Array)) {
							data.emails = c.data.emails.split(',');
							data.emails = _.map(data.emails, k => k.trim().toLowerCase());
						}
						else {
							data.emails = c.data.emails;
						}
						if (data.matchType === this.dic.CONSTANTS.ruleMatchType.exactMatch) {
							const emailsValid = this.gs.validateRuleEmails(data.emails);
							if (!emailsValid) {
								conditionError = true;
								c.invalidEmails = true;
								return;
							}
						}
						this.newRule.conditionAddresses = this.newRule.conditionAddresses.concat(data.emails);
					}
					if (data.matchType === this.dic.CONSTANTS.ruleMatchType.regex) {
						if (!c.data.regex) {
							this.ns.showErrorMessage(this.dic.ERRORS.ruleEmailEmpty);
							conditionError = true;
							c.invalidEmails = true;
							return;
						}
						data.regex = c.data.regex;
						data.regex_flags = c.data.regex_flags;
					}
					break;
			}

			let subType;
			if (this.dic.CONSTANTS.collaborationProtectionRule.types[c.type].subTypes) {
				if (c.singleSubType) {
					subType = c.subType;
				}
				else {
					subType = this.parseSubType(c.subType);
					if (!subType || !subType.length) {
						this.ns.showWarnMessage(this.dic.ERRORS.invalidConditionSubType);
						conditionError = true;
						c.invalidSubTypes = true;
					}
				}
			}

			return {
				type: c.type,
				sub_type: subType,
				data: data,
				is_negate: c.is_negate || false
			};
		});
		return {
			error: conditionError,
			conditions: parsedConditions
		};
	};

	buildOrConditionforBE = (conditionArr) => {
		return {
			type: 'or_condition',
			sub_type: 'email',
			data: null,
			is_negate: false,
			or_conditions: conditionArr
		}
	}

	prepareRuleError = () => {
		this.prepareRuleInProcess = false;
	};

	prepareRule = () => {
		if (!this.newRule) {
			return;
		}

		if (!this.newRule.name || this.newRule.name.length > 100) {
			this.ns.showErrorMessage(this.dic.ERRORS.ruleNameInvalid);
			this.prepareRuleError();
			this.invalidRuleName = true;
			return;
		}

		let ruleData:any = {};
		let conditionError;

		let parsedConditions = this.prepareRuleConditions(this.newRule.conditions);
		conditionError = parsedConditions.error;

		if (conditionError) {
			this.prepareRuleError();
			return;
		}

		ruleData.conditions = parsedConditions.conditions;

		parsedConditions = this.prepareRuleConditions(this.newRule.exceptions);
		conditionError = parsedConditions.error;

		if (conditionError) {
			this.prepareRuleError();
			return;
		}

		ruleData.exceptions = parsedConditions.conditions;

		if (this.newRule.resultShow.length === 0) {
			this.prepareRuleError();
			this.invalidResults = true;
			this.ns.showErrorMessage(this.dic.ERRORS.ruleResultNotSelected);
			return;
		}

		ruleData.result = {
			keep_record: this.newRule.result.keep_record.enabled,
			notify_reviewer: this.newRule.result.notify_reviewer.enabled,
			quarantine_file: this.newRule.result.quarantine_file.enabled,
		};

		ruleData.name = this.newRule.name?.trim();

		this.prepareRuleInProcess = true;

		if (this.newRule._id) {
			this.editRule(ruleData);
		}
		else {
			this.addRule(ruleData);
		}
	};

	editRule = (ruleData) => {
		ruleData.action = this.dic.CONSTANTS.collaborationProtectionRule.actions.update;

		this.rs.updateCollaborationProtectionRule(this.newRule._id, ruleData).then(response => {
			this.rules = response.rules;
			this.config.rules = this.rules;
			this.resetNewRuleData();
			this.parseRulesResultAndExceptions(this.rules);
		}, err => {
			this.prepareRuleInProcess = false;
		});
	};

	addRule = (ruleData) => {
		this.rs.addCollaborationProtectionRule(ruleData).then(response => {
			this.rules = response.rules;
			this.config.rules = this.rules;
			this.resetNewRuleData();
			this.parseRulesResultAndExceptions(this.rules);
		}, err => {
			this.prepareRuleInProcess = false;
		});
	};

	getRuleConditionText = (condition) => {
		if (!condition) {
			return '';
		}

		const typeConfig = this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type];
		condition.text = `<span class="fw-500">${typeConfig.label}</span>`;
		if (typeConfig.noSubType) {
			// resource_type has no "detected in" prefix
		}
		else if (typeConfig.staticSubTypeLabel) {
			condition.text += ` detected in <span class="fw-500">${typeConfig.staticSubTypeLabel}</span>`;
		}
		else {
			condition.text += ` detected in <span class="fw-500">${condition.sub_type?.join(', ')}</span>`;
		}

		switch (condition.type) {
			case this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_type.name:
				if (condition.data.matchType === this.dic.CONSTANTS.ruleMatchType.moreThan) {
					condition.text += ` appears at least <span class="fw-500">${condition.data.matchCount} time${condition.data.matchCount > 1 ? 's' : ''}</span>`;
					condition.text += ` <span class="fw-500">${_.escape(condition.data.sensitivity_types.join(', '))}</span>`;
				}
				else {
					condition.text += ` ${this.parseResultToDisplay(condition, condition.data.sensitivity_types)}`;
				}
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.sensitivity_score.name:
				condition.text += ` is equal or above <span class="fw-500">${condition.data.score_more}</span>`;
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.compliance.name:
				condition.text += ` is <span class="fw-500">${condition.data.compliance.join(', ')}</span>`;
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.keywords.name:
				condition.text += ` ${this.parseResultToDisplay(condition, condition.data.keywords)}`;
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.addresses.name:
				condition.text += ` ${this.parseResultToDisplay(condition, condition.data.emails)}`;
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.attachment_types.name:
				if (condition.data.all_types) {
					condition.text += ` are of any type`;
				}
				else {
					const displays = condition.data.attachment_types.map(type => this.fileTypes[type]?.display);
					condition.text += ` contain <span class="fw-500">${displays.join(', ')}</span>`;
				}
				break;

			case this.dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.name:
				condition.text = `<span class="fw-500">${this.dic.CONSTANTS.collaborationProtectionRule.types.file_permissions.label}</span>`;
				condition.text += ` is <span class="fw-500">${condition.data.file_permissions?.join(', ')}</span>`;
				break;
		}

		if (condition.is_negate) {
			this.editNegativeConditionText(condition);
		}

		condition.originalText = condition.text;
		if (condition.text.length > 400) {
			condition.text = condition.text.substring(0, 400);
			if (condition.text.lastIndexOf(', ') > -1) {
				condition.text = condition.text.substring(0, condition.text.lastIndexOf(', '));
			}
			condition.text += '...';
		}
		else {
			condition.text += '.';
		}
	};

	parseResultToDisplay(condition, values) {
		switch (condition.data.matchType) {
			case this.dic.CONSTANTS.ruleMatchType.exactMatch:
				return `are <span class="fw-500">${_.escape((values || []).join(', '))}</span>`;

			case this.dic.CONSTANTS.ruleMatchType.startsWith:
				return `starts with <span class="fw-500">${_.escape((values || []).join(', '))}</span>`;

			case this.dic.CONSTANTS.ruleMatchType.endsWith:
				return `ends with <span class="fw-500">${_.escape((values || []).join(', '))}</span>`;

			case this.dic.CONSTANTS.ruleMatchType.contains:
				return `contains <span class="fw-500">${_.escape((values || []).join(', '))}</span>`;

			case this.dic.CONSTANTS.ruleMatchType.regex:
				return `match regex <span class="fw-500">/${condition.data.regex}/${condition.data.regex_flags || ''}</span>`;

			case this.dic.CONSTANTS.ruleMatchType.internal:
				return `are <span class="fw-500">internal</span>`;

			case this.dic.CONSTANTS.ruleMatchType.external:
				return `are <span class="fw-500">external</span>`;

			default:
				return `are <span class="fw-500">${condition.data.matchType}</span>`;
		}
	}

	editNegativeConditionText(condition) {
		const connectionWords = ['is', 'are', ..._.values(this.dic.CONSTANTS.ruleMatchType), 'contain'];
		const { word: firstConnectionWord, index } = findFirstOccurrence(connectionWords, condition.text);

		if (firstConnectionWord) {

			if (firstConnectionWord === 'is' || firstConnectionWord === 'are') {
				condition.text = condition.text.slice(0, index + firstConnectionWord.length) + ` <span class="fw-bold text-danger">NOT</span>` + condition.text.slice(index + firstConnectionWord.length);
			}
			else {
				condition.text = condition.text.slice(0, index - 1) + ' <span class="fw-bold text-danger">' + (this.dic.CONSTANTS.collaborationProtectionRule.types[condition.type].isPlural ? 'DO' : 'DOES') + ' NOT</span> ' + condition.text.slice(index);
				if (firstConnectionWord.endsWith('s')) {
					condition.text = condition.text.replace(firstConnectionWord, firstConnectionWord.slice(0, -1));
				}
			}
		}
	}

	searchResults(searchTerm) {
		searchTerm = (searchTerm || '').toLowerCase();

		Object.entries(this.newRule.result).forEach(([key]) => {
			this.newRule.result[key].hide = !this.dic.CONSTANTS.collaborationProtectionRule.defaultResult[key]?.label?.toLowerCase().includes(searchTerm);
		});

		this.searchResultNotFound = Object.values(this.newRule.result).every((type: any) => type.hide);
	}

	clearSearchResults() {
		this.searchResultsText = '';
		this.searchResultNotFound = false;
		Object.values(this.newRule.result).forEach((type: any) => {
			type.hide = false;
		});
	}
}

function findFirstOccurrence(words, text) {
	return words.reduce((first, word) => {
		const match = new RegExp(`\\b${word}\\b`).exec(text);
		const index = match ? match.index : -1;
		return index !== -1 && (first.index === -1 || index < first.index) ? { word, index } : first;
	}, { word: null, index: -1 });
}

function searchTextExecute(rule, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((rule.name?.toLowerCase().indexOf(searchTerm) > -1) ||
		_.some(rule.resultShow, result => result?.toLowerCase().indexOf(searchTerm) > -1) ||
		searchTextInConditions(rule.conditions, searchTerm) ||
		searchTextInConditions(rule.exceptions, searchTerm));
}

function searchTextInConditions(conditions, searchTerm) {
	for (let i = 0; i < conditions.length; i++) {
		const conditionBundle = conditions[i];

		for (let y = 0; y < conditionBundle.length; y++) {
			const condition = conditionBundle[y];
			const conditionText = htmlTextToText(condition.originalText);

			if (conditionText?.toLowerCase().indexOf(searchTerm) > -1) {
				return true;
			}
		}
	}

	return false;
}

function htmlTextToText(htmlText) {
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = htmlText;
	return tempDiv.innerText;
}
